import { TrainingStep } from "../../components/common/TrainingGuide";

const dashboardSteps: TrainingStep[] = [
  {
    title: "Welcome to the AFAQ OS Dashboard",
    description:
      "This is your command center. It shows a live snapshot of every module — WhatsApp activity, CRM pipeline, employee KPIs, and more — all in one place.",
    tip: "Bookmark this page. It's the fastest way to spot problems before they escalate.",
  },
  {
    title: "Reading the KPI Cards",
    description:
      "Each card at the top shows a key metric: active WhatsApp conversations, open CRM leads, today's attendance, and inventory alerts. A colored top border signals status — gold is neutral, green is good, red needs attention.",
    tip: "Click any card to jump directly to that module.",
  },
  {
    title: "Module Overview Cards",
    description:
      "Below the KPIs are module cards — WhatsApp, CRM, Employees, Pricing, and more. Each shows a mini-summary pulled live from the backend. Hover to see the card highlight, click to navigate.",
    tip: "Data refreshes automatically. If something looks stale, do a hard refresh (Ctrl+Shift+R).",
  },
  {
    title: "Navigating Between Modules",
    description:
      "Use the sidebar on the left to switch modules. You can also use keyboard shortcuts: press G then D to return here, G then C for CRM, G then W for WhatsApp, and so on.",
    tip: "Press Ctrl+/ anytime to see the full shortcuts reference.",
  },
  {
    title: "Understanding Live Data",
    description:
      "The dashboard fetches real-time data from the FastAPI backend. If you see a loading spinner or error state, check that the Docker containers are running (afaq-os-v100-backend-1 must be up).",
    tip: "IT tip: run 'docker ps' to confirm all 5 containers are healthy.",
  },
];

export default dashboardSteps;
